import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Paper,
  styled,
} from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory } from "react-router-dom";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
/** Local deoendencies & Libraries */
import Services from '../../../Services';
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { newHirequeTablee, NewHirequeTablee } from "../../../Components/TableComponents/constants";
import NewHireQueeTable from "../../../Components/TableComponents/NewHirequeTable";
import DynamicTable from "../../../Components/TableComponents/DynamicTable";
import { Dropdown, Input, message, Modal, Typography } from "antd";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import swal from "sweetalert";
import SearchBar from "material-ui-search-bar";
import { formatPhoneNumber } from "../../../Components/dummyConstant/DummyConstant";
import { showText } from "../../../helpers/textValidation";
import roleManager from "../../../Components/roles";
import { useSelector } from "react-redux";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
import { Edit } from "@material-ui/icons";
import EmployeePasswordChangeModal from "../../../Components/Modals/EmployeePasswordChange";
import { ArrowDownOutlined, DownOutlined, LockFilled } from "@ant-design/icons";
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import { closeApplicant } from "../../../Services/hr";


const {
  hr
} = Services;



const NewHireQueue = () => {

  const [open, setOpen] = React.useState(false);
  const [selectedApplicant, setselectedApplicant] = useState()
  const [inputSearch, setInputSearch] = useState("")
  const [isPasswordModalOpen, setisPasswordModalOpen] = useState(false)
  const [closeApplicantID, setCloseApplicantID] = useState(null)
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [closingComment, setClosingComment] = useState("")
  const [reload, setReload] = useState(false)
  const [isCloseApplicantModalOpen, setIsCloseApplicantModalOpen] = useState(false)


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let history = useHistory();
  const [reloadFlag, setReloadFlag] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rejectedData, setrejectedData] = useState()

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchData = async () => {
    const offset = 0, limit = 100;
    let params = '?'.concat(seriliazeParams({ offset, limit }))
    let result = await hr.getAllApplicants({ params });
    if (result.httpStatus === 200) {
      return result.data
    }
  }


  const [applicantData, setApplicantData] = useState([])



  const retrieveListing = async (offset = 0, limit = 100) => {
    let params = '?'.concat(seriliazeParams({ offset, limit }))
    try {
      let response = await hr.getAllApplicants({ params });

      if (response?.httpStatus == 200) {
        // 
        let rows = response?.data?.map(col => [

          col?.id + " / " + col?.firstName + " " + col?.lastName,
          col?.SubDepartment?.name,
          col?.city + " , " + col?.state,
          col?.email,
          <div style={{ width: "100px" }}>{formatPhoneNumber(col?.homePhone)}</div>,
          <>
            {col?.closing_comments ? (
              ' Closed - Incomplete Applicant'
            ) : (
              col?.EmployeeStatus?.name
            )}
          </>,
          ([3, 5, 6, 8].includes(col?.ApplicantStatusId)) ?
            <Button onClick={() => onClickView(col)} className={`ViewIcon`} ></Button>
            :
            <VisibilityOffIcon style={{ width: "100%", fontSize: "17px" }} />,
          <Grid style={{ marginLeft: "15px" }} className={` ${(col?.isCompleted) ? `completeTrue` : `CompleteIcon`}`}></Grid>,
          (roleManager('newHireQueue', 'createEmployeeRecord')) ? (col?.ApplicantStatusId === 9 && col?.Employee === false) ?
            <Button style={{ width: '100%' }} onClick={() => { handleClickOpen(); setselectedApplicant(col) }} className={`${(col.ApplicantStatusId === 9 && col?.Employee === false) && 'PersonAddIcon'}`} >
              <PersonAddIcon style={{ width: "100%", fontSize: "17px" }} />
            </Button>
            :
            <PersonAddDisabledIcon style={{ width: "100%", fontSize: "17px" }} /> : 'hide',
          (roleManager('newHireQueue', 'closeApplicant'))
            ?
            <>
              <Dropdown
                menu={{
                  items: [
                    {
                      key: '1',
                      label: (
                        (roleManager('newHireQueue', 'changePassword'))
                          ? ![5, 8, 9]?.includes(col?.EmployeeStatus?.id)
                            ?
                            <Button onClick={() => {
                              setisPasswordModalOpen(true)
                              setSelectedEmployee(col)
                            }}
                              disabled={col?.close_date ? true : false}
                              style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                            >
                              Change Password
                            </Button>
                            :
                            <Button style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}>
                              <NoEncryptionGmailerrorredIcon style={{ fontSize: "18px" }} />
                            </Button>
                          : <Button style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}>
                            N-A
                          </Button>
                      ),
                    },
                    {
                      key: '2',
                      label: (
                        <Button
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                          onClick={() => {
                            setCloseApplicantID(col?.id)
                            setIsCloseApplicantModalOpen(true)
                          }}
                          disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}
                        >
                          Close Applicant
                        </Button>
                      ),
                    }
                  ]
                }}
                placement="bottom"
              >
                <Button style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "gray",
                  border: "1px solid lightgray",
                  textTransform: "capitalize"
                }}>Actions <DownOutlined /> </Button>
              </Dropdown>
            </>
            : (roleManager('newHireQueue', 'changePassword'))
              ? ![5, 8, 9]?.includes(col?.EmployeeStatus?.id)
                ? <>
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: '1',
                          label: (
                            <Button onClick={() => {
                              setisPasswordModalOpen(true)
                              setSelectedEmployee(col)
                            }}
                              disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}

                              style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                            >
                              Change Password
                            </Button>
                          ),
                        },
                        {
                          key: '2',
                          label: (
                            <Button
                              style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                              onClick={() => {
                                setCloseApplicantID(col?.id)
                                setIsCloseApplicantModalOpen(true)
                              }}
                              disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}
                            >
                              Close Applicant
                            </Button>
                          ),
                        }]
                    }}
                    placement="bottom"
                  >
                    <Button style={{
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "gray",
                      border: "1px solid lightgray",
                      textTransform: "capitalize"
                    }}>Actions <DownOutlined /> </Button>
                  </Dropdown>
                </>
                :
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: '1',
                        label: (
                          <Button
                            style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                          >
                            <NoEncryptionGmailerrorredIcon style={{ fontSize: "18px" }} />
                          </Button>
                        ),
                      },]
                  }}
                  placement="bottom"
                >
                  <Button style={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "gray",
                    border: "1px solid lightgray",
                    textTransform: "capitalize"
                  }}>Actions <DownOutlined /> </Button>
                </Dropdown>
              : "hide",
        ])
        let newData = rows?.map((row) => {
          return row?.filter((item, index) => item !== 'hide')
        })
        setApplicantData(newData)
      }
    }
    catch (exc) {
    }
  }
  async function onClickView(value) {

    if ([5, 8].includes(value?.ApplicantStatusId)) {
      let res = await hr.rejectedReason(value?.id)
      setrejectedData(res?.data)
      setIsModalOpen(true)
    }

    if ([3].includes(value?.ApplicantStatusId))
      history.push({
        pathname: "/new-hire-queue/details",
        state: value
      });

    if (value.ApplicantStatusId === 6)
      history.push({
        pathname: "/new-hire-queue/details/approval",
        state: value
      });


  }

  const onEmployeeSubmit = async () => {

    const token = localStorage.getItem("access_jwt")
    const response = await hr.isEmployee(selectedApplicant, {
      'content-type': 'application/json',
      'Authorization': token,
    })


    if (response.httpStatus === 200) {
      swal("Success", `Employee ID: ${response.data.employee.id}`, "success").then(() => {
        handleClose()
        setReloadFlag(!reloadFlag)
        // setApplicantData(fetchData())
      })
    }

  }

  const tableData = {
    header: newHirequeTablee(),
    rows: applicantData?.length ? applicantData : []
  }


  const debounce = (cb, delay = 1000) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay);
    }
  }

  const handleInput = debounce((e) => { setInputSearch(e) })

  const fetchApplicants = async () => {
    if (inputSearch === "") {
      return await retrieveListing()
    }
    const list = await hr.getAllApplicantsByNameNewHireQueue({ name: inputSearch });
    const apiResponse = list?.applicant?.map(col => [

      col?.id + " / " + col?.firstName + " " + col?.lastName,
      col?.SubDepartment?.name,
      col?.city + " , " + col?.state,
      col?.email,
      <div style={{ width: "100px" }}>{formatPhoneNumber(col?.homePhone)}</div>,
      // col?.EmployeeStatus?.name,
      <>
        {col?.closing_comments ? (
          ' Closed - Incomplete Applicant'
        ) : (
          col?.EmployeeStatus?.name
        )}
      </>,
      ([3, 5, 6, 8].includes(col?.ApplicantStatusId)) ?
        <button onClick={() => onClickView(col)} className={`ViewIcon`} ></button>
        :
        <VisibilityOffIcon style={{ width: "100%", fontSize: "17px" }} />,
      <Grid className={` ${(col?.isCompleted) ? `completeTrue` : `CompleteIcon`}`}></Grid>,
      (roleManager('newHireQueue', 'createEmployeeRecord')) ? (col?.ApplicantStatusId === 9 && col?.Employee === false) ?
        <Button style={{ width: '100%' }} onClick={() => { handleClickOpen(); setselectedApplicant(col) }} className={`${(col.ApplicantStatusId === 9 && col?.Employee === false) && 'PersonAddIcon'}`} >
          <PersonAddIcon style={{ width: "100%", fontSize: "17px" }} />
        </Button>
        :
        <PersonAddDisabledIcon style={{ width: "100%", fontSize: "17px" }} /> : 'hide',
      (roleManager('newHireQueue', 'closeApplicant'))
        ?
        <>
          <Dropdown
            menu={{
              items: [
                {
                  key: '1',
                  label: (
                    (roleManager('newHireQueue', 'changePassword'))
                      ? ![5, 8, 9]?.includes(col?.EmployeeStatus?.id)
                        ?
                        <Button onClick={() => {
                          setisPasswordModalOpen(true)
                          setSelectedEmployee(col)
                        }}
                          disabled={col?.close_date ? true : false}
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                        >
                          Change Password
                        </Button>
                        :
                        <Button style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}>
                          <NoEncryptionGmailerrorredIcon style={{ fontSize: "18px" }} />
                        </Button>
                      : <Button style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}>
                        N-A
                      </Button>
                  ),
                },
                {
                  key: '2',
                  label: (
                    <Button
                      style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                      onClick={() => {
                        setCloseApplicantID(col?.id)
                        setIsCloseApplicantModalOpen(true)
                      }}
                      disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}
                    >
                      Close Applicant
                    </Button>
                  ),
                }]
            }}
            placement="bottom"
          >
            <Button style={{
              fontWeight: "500",
              fontSize: "14px",
              color: "gray",
              border: "1px solid lightgray",
              textTransform: "capitalize"
            }}>Actions <DownOutlined /> </Button>
          </Dropdown>
        </>
        : (roleManager('newHireQueue', 'changePassword'))
          ? ![5, 8, 9]?.includes(col?.EmployeeStatus?.id)
            ? <>
              {/* for searching work */}
              <Dropdown
                menu={{
                  items: [
                    {
                      key: '1',
                      label: (
                        <Button onClick={() => {
                          setisPasswordModalOpen(true)
                          setSelectedEmployee(col)
                        }}
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                          disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}

                        >
                          Change Password
                        </Button>
                      ),
                    },
                    {
                      key: '2',
                      label: (
                        <Button
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                          onClick={() => {
                            setCloseApplicantID(col?.id)
                            setIsCloseApplicantModalOpen(true)
                          }}
                          disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}
                        >
                          Close Applicant
                        </Button>
                      ),
                    }]
                }}
                placement="bottom"
              >
                <Button style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "gray",
                  border: "1px solid lightgray",
                  textTransform: "capitalize"
                }}>Actions <DownOutlined /> </Button>
              </Dropdown>
            </>
            : <Dropdown
              menu={{
                // items: [
                //   {
                //     key: '1',
                //     label: (
                //       <Button
                //         style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                //       >
                //         {/* <NoEncryptionGmailerrorredIcon style={{ fontSize: "18px" }} />s */}
                //       </Button>
                //     ),
                //   },]
                items: [
                  {
                    key: '1',
                    label: (
                      ![5, 8, 9]?.includes(col?.EmployeeStatus?.id)
                        ? <Button
                          onClick={() => {
                            setisPasswordModalOpen(true);
                            setSelectedEmployee(col);
                          }}
                          disabled={col?.close_date ? true : false}
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                        >
                          Change Password
                        </Button>
                        : <Button
                          style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                        >
                          <NoEncryptionGmailerrorredIcon style={{ fontSize: "18px" }} />
                        </Button>
                    ),
                  },
                  {
                    key: '2',
                    label: (
                      <Button
                        style={{ width: "200px", fontSize: "12px", border: "1px solid lightgray", borderRadius: "5px", textTransform: "capitalize" }}
                        onClick={() => {
                          setCloseApplicantID(col?.id);
                          setIsCloseApplicantModalOpen(true);
                        }}
                        disabled={col?.close_date ? true : [8, 9, 6]?.includes(col?.ApplicantStatusId) ? true : false}
                      >
                        Close Applicant
                      </Button>
                    ),
                  }
                ]

              }}
              placement="bottom"
            >
              <Button style={{
                fontWeight: "500",
                fontSize: "14px",
                color: "gray",
                border: "1px solid lightgray",
                textTransform: "capitalize"
              }}>Actions <DownOutlined /> </Button>
            </Dropdown>
          : "hide",
    ])
    let newData = apiResponse?.map((row) => {
      return row?.filter((item, index) => item !== 'hide')
    })
    setApplicantData(newData)
  }

  useEffect(() => {
    fetchApplicants(inputSearch)
  }, [inputSearch, reloadFlag, reload])

  return (
    <PageLayout>
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">New Hire Queue</Grid>
        {/* Page Start */}
        <Grid xs={12} className="ContentPage">
          <SearchBar
            value={''}
            style={{ width: '30%', boxShadow: 'none' }}
            onChange={handleInput}
            onCancelSearch={() => setInputSearch('')}
          />
          <Grid xs={12}>
            <Grid
              xs={12}
              container
              justify="space-between"
              className="LiqTables SafetyTable"
            >
              <Paper>

                <Grid xs={12} className="LiqTables ">
                  <Grid xs={12} className="mt28 mb14">
                    <DynamicTable tableData={tableData} resetPage={false} />
                  </Grid>
                  <Grid>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >

                      <DialogContent>
                        <DialogContentText >
                          <span style={{ color: "black" }}>Would you like to add as Employee?</span>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                        <Button onClick={handleClose} style={{ padding: "5px 5px", fontSize: "10px", background: "#f50000c2", color: "white", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);" }}><span>No</span></Button>
                        <Button onClick={onEmployeeSubmit} autoFocus style={{ padding: "5px 5px", fontSize: "10px", background: "#2963ad", color: "white", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);" }}>
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                  <Paper>

                  </Paper>
                </Grid>
              </Paper>

            </Grid>
          </Grid>
        </Grid>
        {/* Page Start End */}
      </Grid>
      <EmployeePasswordChangeModal open={isPasswordModalOpen} close={() => setisPasswordModalOpen(false)} employee={selectedEmployee} />
      <Modal title={"Rejected Applicant"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
        <div className="hr-reject-modal-content">
          <div className="divtwo">
            <span>
              <strong>Rejected By:</strong>  {`${showText(rejectedData?.rejectBy?.CEmployeeId?.firstName)} ${rejectedData?.rejectBy?.CEmployeeId?.lastName ? showText(rejectedData?.rejectBy?.CEmployeeId?.lastName) : ""}`}
            </span>
          </div>
          <div className="divtwo">
            <span>
              <strong>Rejected Reason:</strong> {rejectedData?.steps?.comment}
            </span>
          </div>
        </div>
      </Modal>

      <Modal
        title={"Close Applicant"}
        open={isCloseApplicantModalOpen}
        onOk={handleOk}
        onCancel={() => {
          setIsCloseApplicantModalOpen(false);
          setClosingComment(null)
        }}
        footer={false}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "12px" }}>Closing Comments</span>
            <Input.TextArea rows={4} style={{ fontSize: "11px" }} value={closingComment} onChange={e => setClosingComment(e.target.value)} maxLength={500} />
          </div>
          <Button style={{ background: "#2963AD", color: "white" }} onClick={async () => {
            let response = await closeApplicant({ id: closeApplicantID, comment: closingComment })
            if (response.httpStatus === 200) {
              message.success("Applicant Closed")
              setIsCloseApplicantModalOpen(false)
              setReload(!reload)
              setClosingComment(null)
            }
          }}>submit</Button>
        </div>
      </Modal>
    </PageLayout>

  );
}

export default NewHireQueue;
